<template>
  <product-shop-the-look :product-sets="product?.productSets" @open-shop-the-look="openShopTheLook($event)" />
</template>

<script setup lang="ts">
const { openShopTheLook, product } = usePdp()
</script>
